import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: 'pending' | 'analyzing' | 'generating' | 'completed' | 'failed';
  className?: string;
}

const statusConfig = {
  pending: {
    label: '等待中',
    className: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
  },
  analyzing: {
    label: '分析中',
    className: 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300',
  },
  generating: {
    label: '生成中',
    className: 'bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300',
  },
  completed: {
    label: '已完成',
    className: 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300',
  },
  failed: {
    label: '失败',
    className: 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300',
  },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status];
  
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        config.className,
        className
      )}
    >
      {status === 'analyzing' || status === 'generating' ? (
        <span className="mr-1.5 h-2 w-2 rounded-full bg-current animate-pulse" />
      ) : null}
      {config.label}
    </span>
  );
}
